module.exports = __webpack_public_path__ + "media/images/desktop/app-download-banner-bg-33b7134610febf2171ca17348216f7ea.png";